/***
 * Summary: here resides the scheme and roles for the fields of the network performing
 * 
 */
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const createNumberValidation = (fieldName) =>
    Yup.number()
        .typeError(`Invalid data. '${fieldName}' must be a number`)
        .nullable(true)
        .test('is-number', `Invalid data. '${fieldName}' must be a number`, function (value) {
            return (value === null || value === undefined || !isNaN(value)) || this.createError({ message: `Invalid data. '${fieldName}' must be a number` });
        });



const TODIS_NAIRPORTS_SCHEMA = Yup.object().shape({
    //general section Rules:
    dateValidTo: Yup.date("Valid from is a Date").nullable(true),
    dateValidFrom: Yup.date("Valid to is a Date").nullable(true),
/*     dateValidFor: Yup.string("Valid for is a Year"),
 */    tenTCategory: Yup.string("tent category is alphanumeric").nullable(true),
    nodeNameval: Yup.string("Road ID is alphanumeric").nullable(true),
    nameResp: Yup.string("Road ID is alphanumeric").nullable(true),
    addressResp: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPer: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPos: Yup.string("Road ID is alphanumeric").nullable(true),
    contactNum: Yup.string()
        .transform((originalValue) => {
            // Si el valor comienza con '+', eliminamos ese símbolo
            return typeof originalValue == 'string' ? originalValue.replace(/^\+/, '') : originalValue;
        })
        .nullable(true)
        .test('is-number', 'Invalid data. \'Phone Number\' must be a valid number', function (value) {
            // Ajustamos la expresión regular para permitir 0 y también ajustamos la condición
            const isNumber = /^(0|[1-9][0-9]*)$/.test(value) || value == null || value == undefined;
            if (!isNumber) {
                throw this.createError({ message: 'Invalid data. \'Phone Number\' must be a valid number' });
            }
            return true;
        }),


    contactEmail: Yup.string("Email")
        .transform((originalValue) => {
            // Realizar transformaciones si es necesario
            return typeof originalValue == 'string' ? originalValue.trim() : originalValue;
        })
        .nullable(true)
        .test('is-email', 'Invalid data. \'Email\' must be valid', function (value) {
            // Si el valor es null o undefined, lo consideramos válido y no aplicamos más validaciones
            if (value == null || value == undefined) {
                return true;
            }

            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

            // Verificar si es una cadena antes de intentar dividirla
            if (typeof value == 'string') {
                const emails = value.split(/[,;:]+/);  // Separar por comas, punto y coma, o dos puntos

                for (const email of emails) {
                    if (!emailRegex.test(email.trim())) {
                        throw this.createError({ message: `Invalid data. '${email}' must be a valid email address` });
                    }
                }
            }

            return true;
        }),

    countryCode: Yup.string("Country Code").nullable(true),
    ownershipType: Yup.string().nullable(true),
    owner1: Yup.string().nullable(true),
    ownershipType: Yup.string().nullable(true),
    owner1: Yup.string().nullable(true),
    owner1Per: Yup.number()
        .required("Majority Ownership Porcentage is required")
        .min(0, "Main ownership Porcentage must be greater than or equal to 0")
        .max(100, "Main ownership Porcentage must be less than or equal to 100")
        .test('total-percentage', 'Sum of ownership percentages should be 100%', function (value) {
            const owner1Per = parseFloat(this.parent.owner1Per) || 0;
            const ownerOtherPer = parseFloat(this.parent.ownerOtherPer) || 0;
            return owner1Per + ownerOtherPer == 100;
        }),
    ownerOther: Yup.string()
        .test('ownership-format', 'Invalid ownership format', function (value) {
            // Verificar el formato owner;porcentaje;owner;porcentaje
            if (!value) return true; // Permitir valor vacío
            const pairs = value.split(';');
            // Debe haber un número par de elementos
            if (pairs.length % 2 !== 0) return false;
            // Comprobar si cada par tiene un owner y un porcentaje válido
            for (let i = 0; i < pairs.length; i += 2) {
                const owner = pairs[i].trim();
                const percentage = parseFloat(pairs[i + 1].trim());
                if (!owner || isNaN(percentage) || percentage < 0 || percentage > 100) {
                    return false;
                }
            }
            return true;
        })
        .nullable(true),
    ownerOtherPer: Yup.number()
        .when('ownerOther', {
            is: value => value && value.trim().length > 0,
            then: Yup.number()
                .required('The percentage of secondary owners must be filled in if the "Secondary Owners" field is filled in.') 
                .test('sum-of-percentages', 'Sum of secondary owners should match', function (value) {
                    const pairs = this.parent.ownerOther ? this.parent.ownerOther.split(';') : [];
                    let totalPercentage = 0;
                    for (let i = 1; i < pairs.length; i += 2) {
                        totalPercentage += parseFloat(pairs[i].trim());
                    }
                    return totalPercentage == value;
                })
        })
        .nullable(true),

    remarks: Yup.string("remarks").nullable(true),

    airportsNpmEnvDTO: Yup.object().shape({
        /*         airPollutGhgTpy: createNumberValidation('CO2 emissions (tonnes/year)'),*/
        co2Ems: createNumberValidation('CO2 emissions (tonnes/year)'),
        noxEms: createNumberValidation('NOx emissions (tonnes/year)'),
        so2Ems: createNumberValidation('SO2 emissions (tonnes/year)'),
        nmhcEms: createNumberValidation('Non-methane hydrocarbons (tonnes/year)'),
        ppm: createNumberValidation('Particulate matter (ppm)'),
        /*         noise: createNumberValidation('TODIS'), */
        chFloodInci: createNumberValidation('Flooding incidents (no.)'),
        chClosureAdvWeatherCond: createNumberValidation('Closures due to adverse weather conditions (no.)'),
        /* chEmbankFail: createNumberValidation('TODIS'),
        chWinterMaintDays: createNumberValidation('TODIS'), */
        remarks: Yup.string("description").nullable(true),
    }),
    airportsNpmInfraDTO: Yup.object().shape({
        activity: Yup.string('Value should be a text').nullable(true),
        condition: Yup.string('Value should be a text').nullable(true),
        numRunways: createNumberValidation('Number of runaways (no.)'),
        numPassTerminals: createNumberValidation('Number of passenger terminals (no.)'),
        iataLandingSlotClass: Yup.string('Value should be a text').nullable(true),
        icaoAirportClass: Yup.string('Value should be a text').nullable(true),
        ilsCat: Yup.string('Value should be a text').nullable(true),
        lengthRunways: createNumberValidation('Length of longest runway (m)'),
        passTerminalArea: createNumberValidation('Passenger terminals area (m2)'),
        apronArea: createNumberValidation('Apron area (m2)'),
        apronCapacity: createNumberValidation('Apron capacity (no. of airplanes at the same time)'),
        runwayCapacityFph: createNumberValidation('Runway Capacity (flights/hour)'),
        freightCapacityTpy: createNumberValidation('Freight Capacity (tonnes/year)'),
        declaredCapacity: createNumberValidation('Declared capacity (aircraft movements/h)'),
        passCapacity: createNumberValidation('Passenger capacity (no./year)'),
        railConn: Yup.string('Value should be a text').nullable(true),
        // its: Yup.string('Value should be a text').nullable(true),
        type: Yup.string('Value should be a text').nullable(true),
        preConditionedAirSupply: Yup.boolean().nullable(true),
        alternativeFuelsAvailability: Yup.boolean().nullable(true),
        remarks: Yup.string("description").nullable(true),
    }),
    airportsNpmMaintDTO: Yup.object().shape({
        maintCostTotalPy: createNumberValidation('Maintenance cost - total (Euro/year)'),
        maintCostPassTermPy: createNumberValidation('Maintenance cost - passenger terminals (Euro/year)'),
        maintCostFreightTermPy: createNumberValidation('Maintenance cost - freight terminals (Euro/year)'),
        financeSource: Yup.string('Value should be a text').nullable(true),
        reqUpgradeIncCapPass: Yup.string('Value should be a text').nullable(true),
        reqUpgradeIncRunwaysLen: Yup.string('Value should be a text').nullable(true),
        maintCostRunwaysPy: createNumberValidation('Maintenance cost – runways (Euro/year)'),
        remarks: Yup.string("remarks").nullable(true),
    }),
    airportsNpmOpsDTO: Yup.object().shape({
        passTrafficPy: createNumberValidation('Passenger traffic (no./year)'),
        throughputPy: createNumberValidation('Troughput (no. of aircraft movements/year)'),
        freightTrafficTonsPy: createNumberValidation('Freight traffic (tonnes/year)'),
        capacityUsed: createNumberValidation('Capacity used (% of capacity)'),
        aircraftMovNetCarrirer: createNumberValidation('Type of aircraft movements - network carrier (% of total traffic)'),
        aircraftMovLowcCarrirer: createNumberValidation('Type of aircraft movements - low-cost carrier (% of total traffic)'),
        aircraftMovCharterCarrirer: createNumberValidation('Type of aircraft movements – charters (% of total traffic)'),//falto
        aircraftMovCargoCarrirer: createNumberValidation('Type of aircraft movements – cargo (% of total traffic)'),
        passTransit: createNumberValidation('Passenger transit (% of total traffic)'),
        arrivals: createNumberValidation('Arrivals (% of total traffic)'),
        remarks: Yup.string("description").nullable(true),
    }),
    airportsNpmTentcompDTO: Yup.object().shape({
        railConn: Yup.boolean().nullable(true),
        cleanFuelsAvai: Yup.string('Value should be a text').nullable(true),
        terminalAvai: Yup.boolean().nullable(true),
        remarks: Yup.string("description").nullable(true),
        preConditionedAirSupply: Yup.boolean().nullable(true),
        alternativeFuelsAvailability: Yup.string().nullable(true),
    })
});




const NAIRPORTS_INIT = {
    //general section Rules:
    dateValidTo: "",
    dateValidFrom: "",
    dateValidFor: "",
    tenTCategory: "",
    nodeNameval: "",
    nameResp: "",
    addressResp: "",
    contactPer: "",
    contactPos: "",
    contactNum: 0,
    contactEmail: "",
    countryCode: "",
    ownershipType: "",
    owner1: "",
    owner1Per: "",
    ownerOther: "",
    ownerOtherPer: "",
    remarks: "",
    airportsNpmEnvDTO: {
        airPollutGhgTpy: "",
        co2Ems: "",
        noxEms: "",
        so2Ems: "",
        nmhcEms: "",
        ppm: "",
        noise: "",
        chFloodInci: "",
        chClosureAdvWeatherCond: "",
        chEmbankFail: "",
        chWinterMaintDays: "",
        remarks: "",
    },
    airportsNpmInfraDTO: {
        activity: "",
        condition: "",
        numRunways: "",
        numPassTerminals: "",
        iataLandingSlotClass: "",
        icaoAirportClass: "",
        ilsCat: "",
        lengthRunways: "",
        passTerminalArea: "",
        apronArea: "",
        apronCapacity: "",
        runwayCapacityFph: "",
        freightCapacityTpy: "",
        declaredCapacity: "",
        passCapacity: "",
        railConn: "",
        its: "",
        type: "",
        preConditionedAirSupply: false,
        alternativeFuelsAvailability: false,
        remarks: "",
    },
    airportsNpmMaintDTO: {
        maintCostTotalPy: "",
        maintCostPassTermPy: "",
        maintCostFreightTermPy: "",
        financeSource: "",
        reqUpgradeIncCapPass: "",
        reqUpgradeIncRunwaysLen: "",
        maintCostRunwaysPy: "",
        description: "",
    },
    airportsNpmOpsDTO: {
        throughputPy: "",
        passTrafficPy: "",
        freightTrafficTonsPy: "",
        capacityUsed: "",
        aircraftMovNetCarrirer: "",
        aircraftMovLowcCarrirer: "",
        aircraftMovCharterCarrirer: "",//falto
        aircraftMovCargoCarrirer: "",
        passTransit: "",
        arrivals: "",
        remarks: "",
    },
    airportsNpmTentcompDTO: {
        railConn: false,
        cleanFuelsAvai: false,
        terminalAvai: false,
        remarks: "",
        preConditionedAirSupply: false,
        alternativeFuelsAvailability: "",
    }
}

export { TODIS_NAIRPORTS_SCHEMA, NAIRPORTS_INIT };